import { useContext } from 'react';

import BpkBreakpoint, {
  BREAKPOINTS,
} from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';

import StringsContext from '../Contexts/StringsContext';
import FlightEntry from '../FlightEntry';
import FlightListStatus from '../FlightListStatus';
import PlaceholderFlightEntry from '../PlaceholderFlightEntry';

import type { FlightEntryData } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArrivalsDepartures';

import STYLES from './FlightEntryList.module.scss';

interface FlightEntryListProps {
  entries: FlightEntryData[];
  error?: boolean;
  onRetryButtonClick?: () => void;
  loaded: boolean;
  isFiltering?: boolean;
  showFlightTrackerLinks?: boolean;
  flightTrackerBasePath?: string;
  useUMSFlightTrackerUrls?: boolean;
}

const FlightEntryList = ({
  entries,
  error = undefined,
  flightTrackerBasePath = undefined,
  isFiltering = false,
  loaded,
  onRetryButtonClick = undefined,
  showFlightTrackerLinks = false,
  useUMSFlightTrackerUrls = false,
}: FlightEntryListProps) => {
  const strings = useContext(StringsContext);

  if (!loaded) {
    return (
      <div className={STYLES.FlightEntryListLoading}>
        {Array.from({ length: 20 }).map((_e, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <PlaceholderFlightEntry key={i} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <FlightListStatus
        message={strings.falcon_adb_error_message}
        buttonText={
          strings.falcon_arrivals_departures_board_flightStatus_tryAgain
        }
        onButtonClick={onRetryButtonClick}
        error
      />
    );
  }

  if (isFiltering && entries.length === 0) {
    return (
      <FlightListStatus message={strings.falcon_adb_empty_filtered_results} />
    );
  }

  if (entries.length === 0) {
    return <FlightListStatus message={strings.falcon_adb_error_message} />;
  }

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) => (
        <>
          {entries.map((entry) => (
            <FlightEntry
              isMobile={isMobile}
              key={entry.id}
              showFlightTrackerLinks={showFlightTrackerLinks}
              flightTrackerBasePath={flightTrackerBasePath}
              useUMSFlightTrackerUrls={useUMSFlightTrackerUrls}
              {...entry}
            />
          ))}
        </>
      )}
    </BpkBreakpoint>
  );
};
export default FlightEntryList;
